<template>
<v-chip @click='$emit("selected", location)' v-bind='attrs' >

  <v-icon x-small left v-if='location && location.is_virtual' >mdi-web</v-icon>
  <v-icon v-else x-small left >mdi-map-marker</v-icon>

  {{locationName}}
  <slot name='icon-right' >
  <v-menu :close-on-content-click='false' open-on-hover >
    <template v-slot:activator="{ on }">
    <v-btn v-on='on' slot='activator' small icon >
      <v-icon right small>mdi-clock-outline</v-icon>
    </v-btn>
    </template>
    <v-card width='250' >
      <v-window v-model="window" vertical >
        <v-window-item >
          <v-card >
            <v-card-title class='overline operation-hours-display py-0 grey lighten-4' >
              Operation hours
            </v-card-title>
            <v-divider />
            <v-list dense >
              <template v-for='practitioner in practitioners' >
                <v-list-item
                  v-if='practitioner.is_active'
                  :key='practitioner.id'
                  @click='setPractitioner(practitioner)' >
                  <v-list-item-content>
                    <v-list-item-title>{{practitioner.full_name}}</v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-icon icon small >mdi-chevron-right</v-icon>
                  </v-list-item-action>
                </v-list-item>
              </template>
            </v-list>
          </v-card>
        </v-window-item >
        <v-window-item >
          <v-card v-if='selectedPractitioner' >
            <v-card-title class='overline operation-hours-display py-0 grey lighten-4' >
              <v-btn @click='window=0' icon small >
                <v-icon small>mdi-chevron-left</v-icon>
              </v-btn>
              {{selectedPractitioner.full_name}}
            </v-card-title>
            <v-divider />
            <v-card-text v-if='selectedPractitioner.hours' >
              <v-row><v-col class='py-0 font-weight-bold'>Mon:</v-col> <v-col class='py-0'>{{selectedPractitioner.hours.mon || 'off'}}</v-col></v-row>
              <v-row><v-col class='py-0 font-weight-bold'>Tue:</v-col> <v-col class='py-0'>{{selectedPractitioner.hours.tues || 'off'}}</v-col></v-row>
              <v-row><v-col class='py-0 font-weight-bold'>Wed:</v-col> <v-col class='py-0'>{{selectedPractitioner.hours.wed || 'off'}}</v-col></v-row>
              <v-row><v-col class='py-0 font-weight-bold'>Thu:</v-col> <v-col class='py-0'>{{selectedPractitioner.hours.thurs || 'off'}}</v-col></v-row>
              <v-row><v-col class='py-0 font-weight-bold'>Fri:</v-col> <v-col class='py-0'>{{selectedPractitioner.hours.fri || 'off'}}</v-col></v-row>
              <v-row><v-col class='py-0 font-weight-bold'>Sat:</v-col> <v-col class='py-0'>{{selectedPractitioner.hours.sat || 'off'}}</v-col></v-row>
              <v-row><v-col class='py-0 font-weight-bold'>Sun:</v-col> <v-col class='py-0'>{{selectedPractitioner.hours.sun || 'off'}}</v-col></v-row>
            </v-card-text>
            <v-footer class='caption' >
              {{selectedPractitioner.hours.timezone}}
              <v-spacer  />
              <v-btn :to='editUrl' x-small outlined >Edit</v-btn>
            </v-footer>
            <!-- <pre v-text='selectedPractitioner' /> -->
          </v-card>
        </v-window-item>
      </v-window>
    </v-card>
  </v-menu>
  </slot>
</v-chip>
</template>
<script>
import {mapGetters} from 'vuex'
export default {
  name: 'LocationChip',
  props: {
    spaceId: { required: true },
    locationId: { required: true },
    attrs: { type: Object, default: () => {} }
  },
  data () {
    return {
      window: 0,
      selectedPractitioner: null
    }
  },
  methods: {
    setPractitioner (practitioner) {
      this.selectedPractitioner = practitioner
      this.window++
    }
  },
  computed: {
    ...mapGetters('identity', [
      'getPractitionerById',
      'getLocationBySpaceAndId'
    ]),
    location () {
      return this.getLocationBySpaceAndId(this.spaceId, this.locationId)
    },
    locationName () {
      return this.getObjectPath(this.location, 'name', '')
    },
    editUrl () {
      return `/settings/spaces/${this.spaceId}/locations/${this.locationId}/hours`
    },
    practitioners () {
      let practitioners = []
      if (this.location && this.location.operation_hours) {
        this.location.operation_hours.forEach((hrs) => {
          let isNewPractitioner = practitioners.indexOf(this.practitioner) === -1
          if (hrs.practitioner && isNewPractitioner) {
            let p = this.getPractitionerById(hrs.practitioner)
            if (p) {
              p.hours = hrs
              practitioners.push(p)
            }
          }
        })
      }
      return practitioners
    }
  }
}
</script>
